/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { FETCH_LOCATIONS_REQUEST, FETCH_LOCATIONS_SUCCESS, FETCH_LOCATIONS_FAILURE } from './types';

export const fetchLocationsRequest = () => ({
  type: FETCH_LOCATIONS_REQUEST
});

export const fetchLocationsSuccess = (locations: any, page: any) => {
  return {
    type: FETCH_LOCATIONS_SUCCESS,
    locations: locations,
    page: page
  };
};

export const fetchLocationsFailure = (error: any) => ({
  type: FETCH_LOCATIONS_FAILURE,
  error
});
